import { ComingSoon } from '../RevenueShare/ComingSoon/ComingSoon'

export const TradingScreens = [<ComingSoon />]
